import Vue from 'vue'
import Vuex from 'vuex'
import { getToken, setToken } from '@/utils/auth'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    token: getToken()
  },
  mutations: {
    //存储token方法
    //设置token等于外部传递进来的值
    setToken (state, token) {
      state.token = token
      // localStorage.token = token //同步存储token至localStorage
      setToken(token)
    },

  }
  , getters: {
    //获取token方法
    //判断是否有token,如果没有重新赋值，返回给state的token
    getToken (state) {
      if (!state.token) {
        state.token = getToken()
      }
      return state.token
    }
  },
  actions: {
    setToken (context,token) {
      context.commit('setToken',token)
    }
  }
})

export default store
